import React, { useEffect, useState } from "react";
import { api } from "../lib/apiClient";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useT } from "../lib/i18n";

export const RequestReviewDialog = ({ open, onClose, expert }) => {
  const { t } = useT();
  const navigate = useNavigate();
  const [sessions, setSessions] = useState(null);
  const [selected, setSelected] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/sessions").then((r) => {
      const done = r.data.filter((s) => s.status === "completed");
      setSessions(done);
      if (done[0]) setSelected(done[0].session_id);
    }).catch(() => setSessions([]));
  }, [open]);

  if (!open) return null;

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/review-requests", { consultant_slug: expert.slug, session_id: selected });
      toast.success(t("Review requested — we'll notify you when the expert accepts"));
      onClose();
      navigate("/reviews");
    } catch (e) {
      toast.error(e?.response?.data?.detail || t("Could not request review"));
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 grid place-items-center p-4" data-testid="request-review-dialog">
      <div className="bg-white rounded-xl p-7 w-full max-w-md">
        <div className="flex items-center justify-between">
          <h3 className="font-display font-extrabold text-[#0B1B3D] text-lg">{t("Request Review")}</h3>
          <button data-testid="close-review-dialog" onClick={onClose}><X className="w-5 h-5 text-[#94A3B8]" /></button>
        </div>
        <p className="text-sm text-[#475569] mt-2">
          {expert.first_name} {expert.last_name} · <span className="font-bold text-[#0B1B3D]">€{expert.service?.base_price_eur}</span> · {expert.service?.turnaround || expert.turnaround}
        </p>
        <p className="text-sm font-bold text-[#0B1B3D] mt-4 font-display">{t("Which Decision Report should be reviewed?")}</p>
        {sessions === null ? <p className="text-sm text-[#94A3B8] mt-2">{t("Loading…")}</p> : sessions.length === 0 ? (
          <p className="text-sm text-[#94A3B8] mt-2">{t("You need a completed Decision Report first.")}</p>
        ) : (
          <select data-testid="review-session-select" className="mt-2 w-full border border-slate-200 rounded-lg px-3 py-2.5 text-sm bg-white" value={selected} onChange={(e) => setSelected(e.target.value)}>
            {sessions.map((s) => <option key={s.session_id} value={s.session_id}>{s.title}</option>)}
          </select>
        )}
        <p className="text-xs text-[#94A3B8] mt-3">{t("You will only pay after the expert accepts. Free cancellation before payment.")}</p>
        <button data-testid="confirm-request-review" disabled={busy || !selected} onClick={submit}
          className="mt-5 w-full bg-[#0B1B3D] text-white hover:bg-[#1E3A8A] px-5 py-3 rounded-lg font-bold text-sm font-display disabled:opacity-40">
          {busy ? t("Sending…") : t("Send request")}
        </button>
      </div>
    </div>
  );
};
